import type React from 'react';

import { ChangeDot } from '@change/ds-core-ui';

export const RecordingDot: React.FC<{ isRecording: boolean }> = ({ isRecording }) => {
	if (!isRecording) {
		return null;
	}

	return (
		<div className="animate-pulse" data-testid="recording-dot">
			<ChangeDot size="small" />
		</div>
	);
};
